export default __webpack_public_path__ + "static/media/track_changes.4126b3e1.svg";